import { PropTypes } from 'prop-types';
import styles from './index.module.scss';
import WithBackButton from '../../layout/WithBackButton';
import { Tabs } from 'antd';
import { useIntl } from 'react-intl';

const { actionsWrapper, header } = styles;

const AccionaTableTabs = ({
  selectedTab,
  setSelectedTab,
  render,
  tabs,
  actions,
  title,
}) => {
  const intl = useIntl();
  return (
    <>
      <div className={`row ${actionsWrapper}`}>
        <div className="col-sm-12">{actions}</div>
      </div>
      <div className="row" id="AccionaTable">
        <div className={`col-sm-12 ${header}`}>{title}</div>
        <div className="col-sm-12">
          <Tabs
            destroyOnHidden
            activeKey={selectedTab}
            items={tabs.map((tab) => ({
              key: tab,
              label: intl
                .formatMessage({
                  id: `button${tab[0].toUpperCase()}${tab.substring(1)}`,
                })
                .toUpperCase(),
              children: render(),
            }))}
            onChange={(tab) => setSelectedTab(tab)}
          />
        </div>
      </div>
    </>
  );
};

AccionaTableTabs.propTypes = {
  selectedTab: PropTypes.string.isRequired,
  setSelectedTab: PropTypes.func.isRequired,
  render: PropTypes.func.isRequired,
  tabs: PropTypes.arrayOf(PropTypes.string).isRequired,
  actions: PropTypes.element.isRequired,
  title: PropTypes.string,
  titleClassName: PropTypes.string,
  tabsClassName: PropTypes.string,
};

AccionaTableTabs.defaultProps = {
  title: 'Table',
  titleClassName: undefined,
  tabsClassName: undefined,
};

export default WithBackButton(AccionaTableTabs);
